import CloseIcon from '@rsuite/icons/Close'
import { Close, Search } from '@rsuite/icons'
import ReloadIcon from '@rsuite/icons/Reload'
import SearchIcon from '@rsuite/icons/Search'
import { Button, DatePicker } from 'antd'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { FaPlus, FaSync } from 'react-icons/fa'
import { RiDeleteBin6Line } from 'react-icons/ri'
import Select from 'rsuite/SelectPicker'
import Input from 'rsuite/Input'
import InputGroup from 'rsuite/InputGroup'
import { ItemType, StateParamsModel } from '../Model'
import CheckPermissions from '../checkPermission'
import { Select as SelectAntd } from 'antd'

//includes
import { Form, Formik } from 'formik'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { handleLabelNameChanges } from 'src/cms/helpers/automation'
import DatePickerForGrievance from 'src/cms/helpers/components/forms/DatePickerForGrievance'
import { ISettingTypeState } from '../../siteSettings/components/settings'
import SortModal from './sortModal'

interface Props {
  updateFilterState?: any
  moduleName?: any
  params?: StateParamsModel
  setParams?: any
  filterSelect?: boolean
  filterSelectOptions?: { label: string; value: string | number }[]
  onFilterSelectChange?: (value: string | number) => void
  filterSelectPlaceholder?: string
  filterSelectValue?: string | number

  secondaryFilterSelect?: boolean
  secondaryFilterSelectOptions?: { label: string; value: string | number }[]
  onSecondaryFilterSelectChange?: (value: string | number) => void
  secondaryFilterSelectPlaceholder?: string
  secondaryFilterSelectValue?: string | number
  secondaryFilterSelectDisabled?: boolean

  tertiaryFilterSelect?: boolean
  tertiaryFilterIsMultiple?: boolean
  tertiaryFilterSelectOptions?: { label: string; value: string | number }[]
  onTertiaryFilterSelectChange?: (value: string | number | any) => void
  tertiaryFilterSelectPlaceholder?: string
  tertiaryFilterSelectDisabled?: boolean
  tertiaryFilterSelectValue?: string | number | any

  fourthFilterSelect?: boolean
  fourthFilterSelectOptions?: { label: string; value: string | number }[]
  onFourthFilterSelectChange?: (value: string | number) => void
  fourthFilterSelectPlaceholder?: string
  fourthFilterSelectValue?: string | number

  fifthFilterSelect?: boolean
  fifthFilterSelectOptions?: { label: string; value: string | number }[]
  onFifthFilterSelectChange?: (value: string | number) => void
  fifthFilterSelectPlaceholder?: string
  fifthFilterSelectValue?: string | number

  handleAddModal?: () => void
  handleAddStatus?: () => void
  handleAddNotice?: () => void
  handleAddNotice1?: () => void
  handleAlertOpen?: () => void
  enableMultiple?: () => void
  disableMultiple?: () => void
  handleExport?: any
  showFilterClearButton?: any,
  defaultParams?: any,
  handleRefresh?: () => void
  handleGetAllData?: () => void
  handleTemplateExport?: () => void
  templateLinkShow?: boolean
  templateButtonName?: string
  handleImport?: any
  handleClickImport?: any
  filterData?: boolean
  filterByBranch?: boolean
  addShow?: boolean
  updateShow?: boolean
  showDateFilter?: boolean
  addNoteShow?: boolean
  addNoteMemberTypeShow?: any
  addNoteShow1?: boolean
  showReload?: boolean
  deleteShow?: boolean
  exportShow?: boolean
  exportShowDropdown?: boolean
  importShow?: boolean
  importShow1?: boolean
  syncButtonShow?: boolean
  syncButtonName?: string
  syncButton?: () => void
  toggleMultipleShow?: boolean
  disableButton?: boolean
  exportButtonName?: string
  sortShow?: boolean
  sortButtonName?: string
  activeButtonName?: any
  inactiveButtonName?: string
  openSortModal?: boolean
  setOpenSortModal?: any
  data?: Array<{ [key: string]: string | number }> | undefined
  handleSubmitSort?: (data: Array<ItemType>) => void
  loading?: boolean
  downloadResumeShow?: boolean
  groupDiscussion?: boolean
  interview?: boolean
  handleDownloadResume?: () => void
  enableDiscussion?: () => void
  enableInterview?: () => void
}

const { RangePicker } = DatePicker

const DesignComponent = ({
  showFilterClearButton,
  defaultParams,
  updateFilterState,
  moduleName,
  params,
  setParams,
  groupDiscussion = false,
  interview = false,
  handleAddModal,
  handleAddStatus,
  handleAddNotice,
  handleAddNotice1,
  handleAlertOpen,
  handleClickImport,
  handleExport,
  enableMultiple,
  disableMultiple,
  handleRefresh,
  handleGetAllData,
  handleTemplateExport,
  handleImport,
  showDateFilter = false,
  templateLinkShow = false,
  templateButtonName,
  filterData = false,
  filterByBranch = false,
  addShow = true,
  updateShow = false,
  addNoteShow = false,
  addNoteMemberTypeShow = false,
  addNoteShow1 = false,
  showReload = true,
  deleteShow = true,
  exportShow = true,
  exportShowDropdown = false,
  importShow = true,
  importShow1 = false,
  toggleMultipleShow = true,
  syncButtonShow = false,
  syncButtonName = 'Sync',
  syncButton,
  exportButtonName,
  sortShow,
  sortButtonName,
  activeButtonName,
  inactiveButtonName,
  disableButton,
  data,
  openSortModal,
  setOpenSortModal,
  handleSubmitSort,
  loading,
  handleDownloadResume,
  downloadResumeShow,
  enableDiscussion,
  enableInterview,
  filterSelect = false,
  filterSelectOptions,
  onFilterSelectChange,
  filterSelectPlaceholder,
  filterSelectValue,
  secondaryFilterSelect = false,
  secondaryFilterSelectOptions,
  onSecondaryFilterSelectChange,
  secondaryFilterSelectPlaceholder,
  secondaryFilterSelectValue,
  secondaryFilterSelectDisabled,
  tertiaryFilterSelect = false,
  tertiaryFilterSelectOptions,
  onTertiaryFilterSelectChange,
  tertiaryFilterSelectPlaceholder,
  tertiaryFilterSelectValue,
  tertiaryFilterSelectDisabled,
  tertiaryFilterIsMultiple = false,
  fourthFilterSelect = false,
  fourthFilterSelectOptions,
  onFourthFilterSelectChange,
  fourthFilterSelectPlaceholder,
  fourthFilterSelectValue,
  fifthFilterSelect = false,
  fifthFilterSelectOptions,
  onFifthFilterSelectChange,
  fifthFilterSelectPlaceholder,
  fifthFilterSelectValue,
}: Props) => {
  const [sortData, setSortData] = useState<Array<ItemType>>([])
  const [searchQuery, setSearchQuery] = useState('')
  const [branch, setBranch] = useState<string | null>('')
  const [extraParams, setExtraParams] = useState<any>(params)
  const [selectedExportFormat, setSelectedExportFormat] = useState<'csv' | 'xlsx'>('csv')
  ///just for menu manager
  const setSortInnerData = (data: Array<any>) => {
    if (data.length > 0) {
      const parentIndex = sortData.findIndex((item) => item.keyId === data[0]?.parentId)
      const updatedSortData = [...sortData]
      if (parentIndex >= 0) {
        updatedSortData[parentIndex].children = data
      }
      setSortData(updatedSortData)
    }
  }
  ///just for menu manager
  const setSortInnerMostData = (data: Array<any>) => {
    if (data?.length > 0) {
      const gParentIndex = sortData?.findIndex((item) => item.keyId === data[0]?.topmenuId)

      const parentIndex = sortData[gParentIndex]?.children?.findIndex(
        (item: any) => item.id === data[0]?.parentId
      )

      const updatedSortData = [...sortData]
      if (!isEmpty(updatedSortData?.[gParentIndex]?.children)) {
        if (!isEmpty(updatedSortData?.[gParentIndex]?.children?.[parentIndex]?.children)) {
          updatedSortData[gParentIndex].children[parentIndex].children = [...data]
        }
      }
      setSortData([...updatedSortData])
    }
  }
  const setSortInnerMostChildData = (
    data: Array<any>,
    index1: number,
    index2: number,
    index3: number
  ) => {
    if (data?.length > 0 && index1 >= 0 && index2 >= 0 && index3 >= 0) {
      const updatedSortData = [...sortData]

      if (!isEmpty(updatedSortData?.[index1]?.children)) {
        if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children)) {
          if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children[index3].children)) {
            updatedSortData[index1].children[index2].children[index3].children = [...data]
          }
        }
      }
      setSortData([...updatedSortData])
    }
  }

  useEffect(() => {
    if (!isEmpty(data)) {
      let newSortData: any = data
        ? data?.map((item, i) => {
          return {
            id: i,
            keyId: item?.id,
            name: item?.name,
            title: item?.title,
            parentId: item?.parentId ? item?.parentId : null,
            children: !isEmpty(item?.children) ? item?.children : null,
            menuType: item.menuType,
          }
        })
        : []
      setSortData(newSortData)
    }
  }, [data])

  const handleCloseOpenSortModal = () => {
    setOpenSortModal(false)
  }

  useEffect(() => {
    setExtraParams({ ...params, page: 1, search: searchQuery })
  }, [searchQuery])
  useEffect(() => setExtraParams(params), [params])

  const settings: ISettingTypeState = useSelector((state: any) => state.settingType)

  const showProductAndInterest =
    settings?.data?.setting?.filter((d) => d.name === 'showPopularityAndInterest')[0]?.value === '1'
      ? true
      : false

  return (
    <>
      <div className='row g-0 border-bottom align-items-center mb-3 py-3'>
        <div className='col-lg-6'>
          <div
            className='heading__component__title fw-bolder'
            data-cy={moduleName ? `${handleLabelNameChanges(moduleName)}-title` : ''}
          >
            {moduleName}
          </div>
        </div>
        <div className='col-lg-6'>
          <div className='d-flex justify-content-end'>
            {addShow && (
              <div className='sub_button' onClick={handleAddModal}>
                <CheckPermissions type='Add'>
                  <button className='dt-btn dt-btn-primary' data-cy='add-button'>
                    <FaPlus className='me-2' />
                    Add
                  </button>
                </CheckPermissions>
              </div>
            )}
            {updateShow ? (
              <div
                className='sub_button'
                data-cy='design-update-status-button'
                onClick={handleAddStatus}
              >
                <CheckPermissions type='Add'>
                  <button className='dt-btn dt-btn-primary' data-cy='update-button'>
                    <FaPlus className='me-2' />
                    Update Status
                  </button>
                </CheckPermissions>
              </div>
            ) : null}
            {deleteShow ? (
              <CheckPermissions type='Delete'>
                <div className='sub_button'>
                  <button
                    className='dt-btn dt-btn-secondary'
                    data-cy='delete-button'
                    onClick={handleAlertOpen}
                  >
                    <RiDeleteBin6Line className='me-2' />
                    Delete
                  </button>
                </div>
              </CheckPermissions>
            ) : null}
          </div>
        </div>
      </div>
      {/* <div className='row mb-3'>
        {filterData ? (
          <div className='col-lg-8'>
            <Formik
              initialValues={{
                fromDate: '',
                toDate: '',
              }}
              onSubmit={(values) => {
                setParams({
                  ...params,
                  fromDate: values.fromDate ? moment(values?.fromDate).format('YYYY-MM-DD') : '',
                  toDate: values.toDate ? moment(values?.toDate).format('YYYY-MM-DD') : '',
                })
              }}
              data-cy='design-form'
            >
              {({touched, handleChange, errors, values, setFieldValue}) => {
                return (
                  <Form>
                    {showDateFilter && (
                      <div className='row'>
                        <div className='col-lg-4' style={{zIndex: 11}}>
                          <DatePickerForGrievance
                            containerClassName='col-12'
                            name='fromDate'
                            placeholderText='From date'
                            setFieldValue={setFieldValue}
                            value={values.fromDate || false}
                            touched={touched}
                            required={true}
                            showIcon={true}
                            errors={errors}
                          />
                        </div>
                        <div className='col-lg-4' style={{zIndex: 11}}>
                          <DatePickerForGrievance
                            containerClassName='col-12'
                            name='toDate'
                            placeholderText='To date'
                            setFieldValue={setFieldValue}
                            value={values.toDate || false}
                            touched={touched}
                            required={true}
                            showIcon={true}
                            errors={errors}
                          />
                        </div>
                        <div className='col-lg-3 '>
                          <button
                            type='submit'
                            disabled={loading}
                            className='btn btn-primary btn'
                            data-cy='design-filter-button'
                          >
                            Filter
                          </button>
                        </div>
                      </div>
                    )}
                  </Form>
                )
              }}
            </Formik>
          </div>
        ) : null}
      </div> */}
      {templateLinkShow ? (
        <div className='d-flex justify-content-end align-items-center mb-5'>
          <div className='sub_button'>
            <button
              className='dt-btn dt-btn-outline-primary dt-btn-sm'
              onClick={handleTemplateExport}
              data-cy={`${handleLabelNameChanges(moduleName)}-export-button`}
            >
              {templateButtonName}
            </button>
          </div>
        </div>
      ) : null}

      <div className="ps-3">
        <div className="container-full mb-4">
          <div className='row align-items-center gap-2'>
            <InputGroup className='col-12 col-sm-6 col-md-4 col-lg-4'>
              <Input
                placeholder='Search'
                value={extraParams?.search}
                onChange={(value) => setExtraParams({ ...params, ...extraParams, search: value })}
                data-cy='search-field'
              />
              <InputGroup.Addon>
                {!isEmpty(extraParams?.search) ? (
                  <Close
                    style={{ cursor: 'pointer' }}
                    onClick={() => setExtraParams({ ...params, ...extraParams, search: '' })}
                    data-cy='search-close-button'
                  />
                ) : (
                  <Search />
                )}
              </InputGroup.Addon>
            </InputGroup>
            {showDateFilter && (
              <>
                <div className='col-12 col-sm-6 col-md-4 col-lg-2 p-0'>
                  <DatePicker
                    placement='bottomLeft'
                    className='w-100'
                    popupStyle={{ zIndex: 1000 }}
                    maxDate={dayjs()}
                    size='middle'

                    onChange={(date: any) => {
                      if (!date) {
                        setExtraParams({
                          ...params,
                          ...extraParams,
                          fromDate: '',
                          toDate: null,
                        })
                      } else {
                        setExtraParams({
                          ...params,
                          ...extraParams,
                          fromDate: dayjs(date?.$d).format('YYYY/MM/DD'),
                          toDate: null,
                        })
                      }
                    }}
                  />

                </div>
                <div className='col-12 col-sm-6 col-md-4 col-lg-2 p-0'>
                  <DatePicker
                    placement='bottomLeft'
                    popupStyle={{ zIndex: 1000 }}
                    className='w-100'
                    size='middle'
                    value={extraParams?.toDate ? dayjs(extraParams?.toDate) : null}
                    minDate={dayjs(extraParams?.fromDate)}
                    maxDate={dayjs()}
                    disabled={!extraParams?.fromDate}
                    onChange={(date: any) => {
                      if (!date) {
                        setExtraParams({
                          ...params,
                          ...extraParams,
                          toDate: '',
                        })
                      } else {
                        setExtraParams({
                          ...params,
                          ...extraParams,
                          toDate: dayjs(date?.$d).format('YYYY/MM/DD'),
                        })
                      }
                    }}
                  />
                </div>
              </>
            )}
            <div className='col-12 col-sm-6 col-md-4 col-lg-1 p-0'>
              <Button
                className='dt-btn dt-btn-sm dt-btn-primary w-100'
                onClick={() => updateFilterState(extraParams)}
                data-cy='export-button'
                loading={loading}
              >
                {"Filter"}
              </Button>
            </div>
            {showFilterClearButton &&
              <div className='col-12 col-sm-6 col-md-4 col-lg-1 p-0'>
                <Button
                  className='dt-btn dt-btn-sm dt-btn-primary w-100'
                  onClick={() => updateFilterState(defaultParams)}
                  data-cy='export-button'
                >
                  {"Clear"}
                </Button>
              </div>
            }
          </div>
        </div>
        <div className="container-full mb-2">
          <div className="row g-2 align-items-center">
            {filterByBranch && (
              <div className="col-12 col-sm-6 col-md-4 col-lg-2" style={{ zIndex: 10 }}>
                <Select
                  data={[]}
                  placeholder='Filter by Branch'
                  onChange={(value) => setBranch('')}
                />
              </div>
            )}
            {filterSelect && filterSelectOptions && (
              <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                <SelectAntd
                  className="w-100"
                  placeholder={filterSelectPlaceholder || 'Select an option'}
                  value={filterSelectValue || undefined}
                  onChange={onFilterSelectChange}
                  options={filterSelectOptions}
                  allowClear
                  showSearch
                  optionFilterProp='label'
                />
              </div>
            )}
            {secondaryFilterSelect && secondaryFilterSelectOptions && (
              <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                <SelectAntd
                  className="w-100"
                  placeholder={secondaryFilterSelectPlaceholder || 'Select an option'}
                  value={secondaryFilterSelectValue || undefined}
                  onChange={onSecondaryFilterSelectChange}
                  options={secondaryFilterSelectOptions}
                  disabled={secondaryFilterSelectDisabled}
                  allowClear
                  showSearch
                  optionFilterProp='label'
                />
              </div>
            )}

            {tertiaryFilterSelect && tertiaryFilterSelectOptions && (
              <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                {tertiaryFilterIsMultiple ? (
                  <SelectAntd
                    mode='multiple'
                    className="w-100"
                    placeholder={tertiaryFilterSelectPlaceholder || 'Select an option'}
                    value={tertiaryFilterSelectValue || undefined}
                    onChange={onTertiaryFilterSelectChange}
                    options={tertiaryFilterSelectOptions}
                    allowClear
                    disabled={tertiaryFilterSelectDisabled}
                    showSearch
                    optionFilterProp='label'
                    maxTagCount={1}
                    size='small'
                  />
                ) : (
                  <SelectAntd
                    className="w-100"
                    placeholder={tertiaryFilterSelectPlaceholder || 'Select an option'}
                    value={tertiaryFilterSelectValue || undefined}
                    onChange={onTertiaryFilterSelectChange}
                    options={tertiaryFilterSelectOptions}
                    disabled={tertiaryFilterSelectDisabled}
                    allowClear
                    showSearch
                    optionFilterProp='label'
                  />
                )}
              </div>
            )}

            {fourthFilterSelect && fourthFilterSelectOptions && (
              <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                <SelectAntd
                  className="w-100"
                  placeholder={fourthFilterSelectPlaceholder || 'Select an option'}
                  value={fourthFilterSelectValue || undefined}
                  onChange={onFourthFilterSelectChange}
                  options={fourthFilterSelectOptions}
                  allowClear
                  showSearch
                  optionFilterProp='label'
                />
              </div>
            )}

            {fifthFilterSelect && fifthFilterSelectOptions && (
              <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                <SelectAntd
                  className="w-100"
                  placeholder={fifthFilterSelectPlaceholder || 'Select an option'}
                  value={fifthFilterSelectValue || undefined}
                  onChange={onFifthFilterSelectChange}
                  options={fifthFilterSelectOptions}
                  allowClear
                  showSearch
                  optionFilterProp='label'
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-end mb-4'>
        {showReload && (
          <div className='sub_button'>
            <button
              className='dt-btn dt-btn-outline-primary dt-btn-sm'
              onClick={handleRefresh}
              data-cy='refresh-button'
            >
              <ReloadIcon />
            </button>
          </div>
        )}
        {syncButtonShow && (
          <div className='sub_button'>
            <button
              className='d-flex align-items-center justify-content-center dt-btn dt-btn-primary dt-btn-sm gap-2'
              onClick={syncButton}
              data-cy='refresh-button'
            >
              <FaSync />{' '}
              <div>
                {syncButtonName}
              </div>
            </button>
          </div>
        )}
        {addNoteShow ? (
          <div className='sub_button' onClick={handleAddNotice} data-cy='update-note-button'>
            <CheckPermissions type='Add'>
              <button className='dt-btn dt-btn-outline-primary dt-btn-sm'>
                {addNoteShow1 ? 'Update Deposit Note' : 'Update Note'}
              </button>
            </CheckPermissions>
          </div>
        ) : null}

        {addNoteMemberTypeShow ? (
          <div className='sub_button' onClick={handleAddNotice} data-cy='update-member-note-button'>
            <CheckPermissions type='Add'>
              <button className='dt-btn dt-btn-outline-primary dt-btn-sm'>
                {addNoteShow1 ? 'Update Deposit Note' : 'Update Note'}
              </button>
            </CheckPermissions>
          </div>
        ) : null}

        {addNoteShow1 ? (
          <div className='sub_button' onClick={handleAddNotice1} data-cy='update-loan-note-button'>
            <CheckPermissions type='Add'>
              -<button className='dt-btn dt-btn-outline-primary dt-btn-sm'>Update Loan Note</button>
            </CheckPermissions>
          </div>
        ) : null}

        {downloadResumeShow ? (
          <div
            className='sub_button'
            onClick={handleDownloadResume}
            data-cy='download-document-button'
          >
            <CheckPermissions type='Add'>
              <button className='dt-btn dt-btn-outline-primary dt-btn-sm'>Download Document</button>
            </CheckPermissions>
          </div>
        ) : null}

        {!showProductAndInterest ? (
          ''
        ) : (
          <>
            {groupDiscussion ? (
              <div className='sub_button'>
                <button
                  className='dt-btn dt-btn-outline-primary dt-btn-sm'
                  onClick={enableDiscussion}
                  disabled={disableButton}
                  data-cy='group-discussion-button'
                >
                  {'Shortlist for Group Discussion'}
                </button>
              </div>
            ) : null}
            {interview ? (
              <div className='sub_button'>
                <button
                  className='dt-btn dt-btn-outline-primary dt-btn-sm'
                  onClick={enableInterview}
                  disabled={disableButton}
                  data-cy='interview-button'
                >
                  {'Shortlist for Interview'}
                </button>
              </div>
            ) : null}
          </>
        )}
        {toggleMultipleShow ? (
          <>
            <div className='sub_button'>
              <button
                className='dt-btn dt-btn-outline-primary dt-btn-sm'
                onClick={enableMultiple}
                disabled={disableButton}
                data-cy='toggle-multiple-show-button'
              >
                {activeButtonName || 'Active'}
              </button>
            </div>
            <div className='sub_button'>
              <button
                className='dt-btn dt-btn-outline-primary dt-btn-sm'
                onClick={disableMultiple}
                data-cy='toggle-multiple-active-inactive-button'
              >
                {inactiveButtonName || 'Inactive'}
              </button>
            </div>
          </>
        ) : null}
        {exportShow ? (
          <div className='sub_button'>
            {exportShowDropdown ? (
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <SelectAntd
                  value={selectedExportFormat}
                  onChange={(value) => setSelectedExportFormat(value as 'csv' | 'xlsx')}
                  style={{ width: '120px' }}
                  data-cy='export-format-select'
                >
                  <SelectAntd.Option value='csv'>CSV</SelectAntd.Option>
                  <SelectAntd.Option value='xlsx'>XLSX</SelectAntd.Option>
                </SelectAntd>
                <button
                  className='dt-btn dt-btn-primary dt-btn-lg'
                  onClick={() => handleExport(selectedExportFormat)}
                  data-cy='export-button'
                >
                  Export
                </button>
              </div>
            ) : (
              <button
                className='dt-btn dt-btn-primary dt-btn-lg'
                onClick={handleExport}
                data-cy='export-button'
              >
                {exportButtonName || 'Export to CSV'}
              </button>
            )}
          </div>
        ) : null}
        {importShow ? (
          <div className='sub_button'>
            <form action='#'>
              <div className='input-file-container'>
                <input
                  className='input-file'
                  id='my-file'
                  type='file'
                  onChange={handleImport}
                  data-cy='import-file-link'
                />
                <label
                  className='dt-btn dt-btn-outline-primary dt-btn-sm input-file-trigger'
                  htmlFor='my-file'
                >
                  Import
                </label>
              </div>
            </form>
          </div>
        ) : null}

        {importShow1 ? (
          <button
            className='dt-btn dt-btn-outline-primary dt-btn-sm ms-2'
            onClick={handleClickImport}
            data-cy='import-show-button'
          >
            Import
          </button>
        ) : null}

        {sortShow ? (
          <div
            className='sub_button'
            onClick={async () => {
              handleGetAllData && handleGetAllData()
              setOpenSortModal(true)
            }}
            data-cy='sort-show-button'
          >
            <button className='dt-btn dt-btn-outline-primary dt-btn-sm' data-cy='sort-button'>
              {sortButtonName || 'Sort'}
            </button>
          </div>
        ) : null}
      </div>

      <SortModal
        isOpen={openSortModal}
        handleClose={handleCloseOpenSortModal}
        data={sortData}
        setSortData={setSortData}
        sortButtonName={sortButtonName}
        handleSubmitSort={handleSubmitSort}
        loading={loading}
        setSortInnerData={setSortInnerData}
        setSortInnerMostData={setSortInnerMostData}
        setSortInnerMostChildData={setSortInnerMostChildData}
      />
    </>
  )
}

export default DesignComponent

// import CloseIcon from '@rsuite/icons/Close'
// import ReloadIcon from '@rsuite/icons/Reload'
// import SearchIcon from '@rsuite/icons/Search'
// import {isEmpty} from 'lodash'
// import {useEffect, useState} from 'react'
// import {FaPlus} from 'react-icons/fa'
// import {RiDeleteBin6Line} from 'react-icons/ri'
// import Select from 'rsuite/SelectPicker'
// import Input from 'rsuite/Input'
// import InputGroup from 'rsuite/InputGroup'
// import {ItemType, StateParamsModel} from '../Model'
// import CheckPermissions from '../checkPermission'

// //includes
// import {Form, Formik} from 'formik'
// import moment from 'moment'
// import {useSelector} from 'react-redux'
// import {handleLabelNameChanges} from 'src/cms/helpers/automation'
// import DatePickerForGrievance from 'src/cms/helpers/components/forms/DatePickerForGrievance'
// import {ISettingTypeState} from '../../siteSettings/components/settings'
// import SortModal from './sortModal'

// interface Props {
//   moduleName: string
//   params?: StateParamsModel
//   setParams?: any
//   handleAddModal?: () => void
//   handleAddStatus?: () => void
//   handleAddNotice?: () => void
//   handleAddNotice1?: () => void
//   handleAlertOpen?: () => void
//   enableMultiple?: () => void
//   disableMultiple?: () => void
//   handleExport?: () => void
//   handleRefresh?: () => void
//   handleGetAllData?: () => void
//   handleTemplateExport?: () => void
//   templateLinkShow?: boolean
//   templateButtonName?: string
//   handleImport?: any
//   handleClickImport?: any
//   filterData?: boolean
//   filterByBranch?: boolean
//   addShow?: boolean
//   updateShow?: boolean
//   addNoteShow?: boolean
//   addNoteMemberTypeShow?: any
//   addNoteShow1?: boolean
//   deleteShow?: boolean
//   exportShow?: boolean
//   importShow?: boolean
//   importShow1?: boolean
//   toggleMultipleShow?: boolean
//   disableButton?: boolean
//   exportButtonName?: string
//   sortShow?: boolean
//   sortButtonName?: string
//   activeButtonName?: any
//   inactiveButtonName?: string
//   openSortModal?: boolean
//   setOpenSortModal?: any
//   data?: Array<{[key: string]: string | number}> | undefined
//   handleSubmitSort?: (data: Array<ItemType>) => void
//   loading?: boolean
//   downloadResumeShow?: boolean
//   groupDiscussion?: boolean
//   interview?: boolean
//   handleDownloadResume?: () => void
//   enableDiscussion?: () => void
//   enableInterview?: () => void
// }

// const DesignComponent = ({
//   moduleName,
//   params,
//   setParams,
//   groupDiscussion = false,
//   interview = false,
//   handleAddModal,
//   handleAddStatus,
//   handleAddNotice,
//   handleAddNotice1,
//   handleAlertOpen,
//   handleClickImport,
//   handleExport,
//   enableMultiple,
//   disableMultiple,
//   handleRefresh,
//   handleGetAllData,
//   handleTemplateExport,
//   handleImport,
//   templateLinkShow = false,
//   templateButtonName,
//   filterData = false,
//   filterByBranch = false,
//   addShow = true,
//   updateShow = false,
//   addNoteShow = false,
//   addNoteMemberTypeShow = false,
//   addNoteShow1 = false,
//   deleteShow = true,
//   exportShow = true,
//   importShow = true,
//   importShow1 = false,
//   toggleMultipleShow = true,
//   exportButtonName,
//   sortShow,
//   sortButtonName,
//   activeButtonName,
//   inactiveButtonName,
//   disableButton,
//   data,
//   openSortModal,
//   setOpenSortModal,
//   handleSubmitSort,
//   loading,
//   handleDownloadResume,
//   downloadResumeShow,
//   enableDiscussion,
//   enableInterview,
// }: Props) => {
//   const [sortData, setSortData] = useState<Array<ItemType>>([])
//   const [searchQuery, setSearchQuery] = useState('')
//   const [branch, setBranch] = useState<string | null>('')

//   ///just for menu manager
//   const setSortInnerData = (data: Array<any>) => {
//     if (data.length > 0) {
//       const parentIndex = sortData.findIndex((item) => item.keyId === data[0]?.parentId)
//       const updatedSortData = [...sortData]
//       if (parentIndex >= 0) {
//         updatedSortData[parentIndex].children = data
//       }
//       setSortData(updatedSortData)
//     }
//   }
//   ///just for menu manager
//   const setSortInnerMostData = (data: Array<any>) => {
//     if (data?.length > 0) {
//       const gParentIndex = sortData?.findIndex((item) => item.keyId === data[0]?.topmenuId)

//       const parentIndex = sortData[gParentIndex]?.children?.findIndex(
//         (item: any) => item.id === data[0]?.parentId
//       )

//       const updatedSortData = [...sortData]
//       if (!isEmpty(updatedSortData?.[gParentIndex]?.children)) {
//         if (!isEmpty(updatedSortData?.[gParentIndex]?.children?.[parentIndex]?.children)) {
//           updatedSortData[gParentIndex].children[parentIndex].children = [...data]
//         }
//       }
//       setSortData([...updatedSortData])
//     }
//   }
//   const setSortInnerMostChildData = (
//     data: Array<any>,
//     index1: number,
//     index2: number,
//     index3: number
//   ) => {
//     if (data?.length > 0 && index1 >= 0 && index2 >= 0 && index3 >= 0) {
//       const updatedSortData = [...sortData]

//       if (!isEmpty(updatedSortData?.[index1]?.children)) {
//         if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children)) {
//           if (!isEmpty(updatedSortData?.[index1]?.children?.[index2]?.children[index3].children)) {
//             updatedSortData[index1].children[index2].children[index3].children = [...data]
//           }
//         }
//       }
//       setSortData([...updatedSortData])
//     }
//   }

//   useEffect(() => {
//     if (!isEmpty(data)) {
//       let newSortData: any = data
//         ? data?.map((item, i) => {
//             return {
//               id: i,
//               keyId: item?.id,
//               name: item?.name,
//               title: item?.title,
//               parentId: item?.parentId ? item?.parentId : null,
//               children: !isEmpty(item?.children) ? item?.children : null,
//               menuType: item.menuType,
//             }
//           })
//         : []
//       setSortData(newSortData)
//     }
//   }, [data])

//   const handleCloseOpenSortModal = () => {
//     setOpenSortModal(false)
//   }

//   useEffect(() => {
//     setParams({...params, page: 1, search: searchQuery})
//   }, [searchQuery])
//   const settings: ISettingTypeState = useSelector((state: any) => state.settingType)

//   const showProductAndInterest =
//     settings?.data?.setting?.filter((d) => d.name === 'showPopularityAndInterest')[0]?.value === '1'
//       ? true
//       : false

//   return (
//     <>
//       <div className='row g-0 border-bottom align-items-center mb-3 py-3'>
//         <div className='col-lg-6'>
//           <div
//             className='heading__component__title fw-bolder'
//             data-cy={moduleName ? `${handleLabelNameChanges(moduleName)}-title` : ''}
//           >
//             {moduleName}
//           </div>
//         </div>
//         <div className='col-lg-6'>
//           <div className='d-flex justify-content-end'>
//             {addShow ? (
//               <div className='sub_button' onClick={handleAddModal}>
//                 <CheckPermissions type='Add'>
//                   <button className='dt-btn dt-btn-primary' data-cy='add-button'>
//                     <FaPlus className='me-2' />
//                     Add
//                   </button>
//                 </CheckPermissions>
//               </div>
//             ) : null}
//             {updateShow ? (
//               <div
//                 className='sub_button'
//                 data-cy='design-update-status-button'
//                 onClick={handleAddStatus}
//               >
//                 <CheckPermissions type='Add'>
//                   <button className='dt-btn dt-btn-primary' data-cy='update-button'>
//                     <FaPlus className='me-2' />
//                     Update Status
//                   </button>
//                 </CheckPermissions>
//               </div>
//             ) : null}
//             {deleteShow ? (
//               <CheckPermissions type='Delete'>
//                 <div className='sub_button'>
//                   <button
//                     className='dt-btn dt-btn-secondary'
//                     data-cy='delete-button'
//                     onClick={handleAlertOpen}
//                   >
//                     <RiDeleteBin6Line className='me-2' />
//                     Delete
//                   </button>
//                 </div>
//               </CheckPermissions>
//             ) : null}
//           </div>
//         </div>
//       </div>
//       {filterData ? (
//         <div className='d-flex me-5 mb-3'>
//           <div className='d-flex'>
//             <Formik
//               initialValues={{
//                 fromDate: '',
//                 toDate: '',
//               }}
//               onSubmit={(values) => {
//                 setParams({
//                   ...params,
//                   fromDate: values.fromDate ? moment(values?.fromDate).format('YYYY-MM-DD') : '',
//                   toDate: values.toDate ? moment(values?.toDate).format('YYYY-MM-DD') : '',
//                 })
//               }}
//               data-cy='design-form'
//             >
//               {({touched, handleChange, errors, values, setFieldValue}) => {
//                 return (
//                   <Form>
//                     <div className='d-flex flex-row'>
//                       <div className='col-5' style={{zIndex: 11}}>
//                         <DatePickerForGrievance
//                           containerClassName='col-12'
//                           name='fromDate'
//                           placeholderText='From date'
//                           setFieldValue={setFieldValue}
//                           value={values.fromDate || false}
//                           touched={touched}
//                           required={true}
//                           showIcon={true}
//                           errors={errors}
//                         />
//                       </div>
//                       <div className='col-5 ms-5' style={{zIndex: 11}}>
//                         <DatePickerForGrievance
//                           containerClassName='col-12'
//                           name='toDate'
//                           placeholderText='To date'
//                           setFieldValue={setFieldValue}
//                           value={values.toDate || false}
//                           touched={touched}
//                           required={true}
//                           showIcon={true}
//                           errors={errors}
//                         />
//                       </div>
//                       <div className='col-5 ms-5'>
//                         <button
//                           type='submit'
//                           disabled={loading}
//                           className='btn btn-primary btn'
//                           data-cy='design-filter-button'
//                         >
//                           Filter
//                         </button>
//                       </div>
//                     </div>
//                   </Form>
//                 )
//               }}
//             </Formik>
//           </div>
//         </div>
//       ) : null}

//       {templateLinkShow ? (
//         <div className='d-flex justify-content-end align-items-center mb-5'>
//           <div className='sub_button'>
//             <button
//               className='dt-btn dt-btn-outline-primary dt-btn-sm'
//               onClick={handleTemplateExport}
//               data-cy={`${handleLabelNameChanges(moduleName)}-export-button`}
//             >
//               {templateButtonName}
//             </button>
//           </div>
//         </div>
//       ) : null}

//       <div className='d-flex justify-content-between align-items-center mb-5'>
//         <div className='d-flex'>
//           <InputGroup inside>
//             <Input
//               placeholder='Search'
//               value={searchQuery}
//               onChange={(value: string) => setSearchQuery(value)}
//               data-cy='search-field'
//             />
//             <InputGroup.Addon>
//               {!isEmpty(params?.search) ? (
//                 <CloseIcon
//                   style={{cursor: 'pointer'}}
//                   onClick={() => setSearchQuery('')}
//                   data-cy='search-close-button'
//                 />
//               ) : (
//                 <SearchIcon />
//               )}
//               {/* <SearchIcon /> */}
//             </InputGroup.Addon>
//           </InputGroup>
//           {filterByBranch && (
//             <div className='ms-2' style={{zIndex: 10}}>
//               <Select
//                 data={[]}
//                 placeholder='Filter by Branch'
//                 onChange={(value) => setBranch('')}
//               />
//             </div>
//           )}
//         </div>

//         <div className='d-flex'>
//           <div className='d-flex'>
//             <div className='sub_button'>
//               <button
//                 className='dt-btn dt-btn-outline-primary dt-btn-sm'
//                 onClick={handleRefresh}
//                 data-cy='refresh-button'
//               >
//                 <ReloadIcon />
//               </button>
//             </div>
//             {addNoteShow ? (
//               <div className='sub_button' onClick={handleAddNotice} data-cy='update-note-button'>
//                 <CheckPermissions type='Add'>
//                   <button className='dt-btn dt-btn-outline-primary dt-btn-sm'>
//                     {addNoteShow1 ? 'Update Deposit Note' : 'Update Note'}
//                   </button>
//                 </CheckPermissions>
//               </div>
//             ) : null}

//             {addNoteMemberTypeShow ? (
//               <div
//                 className='sub_button'
//                 onClick={handleAddNotice}
//                 data-cy='update-member-note-button'
//               >
//                 <CheckPermissions type='Add'>
//                   <button className='dt-btn dt-btn-outline-primary dt-btn-sm'>
//                     {addNoteShow1 ? 'Update Deposit Note' : 'Update Note'}
//                   </button>
//                 </CheckPermissions>
//               </div>
//             ) : null}

//             {addNoteShow1 ? (
//               <div
//                 className='sub_button'
//                 onClick={handleAddNotice1}
//                 data-cy='update-loan-note-button'
//               >
//                 <CheckPermissions type='Add'>
//                   -
//                   <button className='dt-btn dt-btn-outline-primary dt-btn-sm'>
//                     Update Loan Note
//                   </button>
//                 </CheckPermissions>
//               </div>
//             ) : null}

//             {downloadResumeShow ? (
//               <div
//                 className='sub_button'
//                 onClick={handleDownloadResume}
//                 data-cy='download-document-button'
//               >
//                 <CheckPermissions type='Add'>
//                   <button className='dt-btn dt-btn-outline-primary dt-btn-sm'>
//                     Download Document
//                   </button>
//                 </CheckPermissions>
//               </div>
//             ) : null}

//             {!showProductAndInterest ? (
//               ''
//             ) : (
//               <>
//                 {groupDiscussion ? (
//                   <div className='sub_button'>
//                     <button
//                       className='dt-btn dt-btn-outline-primary dt-btn-sm'
//                       onClick={enableDiscussion}
//                       disabled={disableButton}
//                       data-cy='group-discussion-button'
//                     >
//                       {'Shortlist for Group Discussion'}
//                     </button>
//                   </div>
//                 ) : null}
//                 {interview ? (
//                   <div className='sub_button'>
//                     <button
//                       className='dt-btn dt-btn-outline-primary dt-btn-sm'
//                       onClick={enableInterview}
//                       disabled={disableButton}
//                       data-cy='interview-button'
//                     >
//                       {'Shortlist for Interview'}
//                     </button>
//                   </div>
//                 ) : null}
//               </>
//             )}
//             {toggleMultipleShow ? (
//               <>
//                 <div className='sub_button'>
//                   <button
//                     className='dt-btn dt-btn-outline-primary dt-btn-sm'
//                     onClick={enableMultiple}
//                     disabled={disableButton}
//                     data-cy='toggle-multiple-show-button'
//                   >
//                     {activeButtonName || 'Active'}
//                   </button>
//                 </div>
//                 <div className='sub_button'>
//                   <button
//                     className='dt-btn dt-btn-outline-primary dt-btn-sm'
//                     onClick={disableMultiple}
//                     data-cy='toggle-multiple-active-inactive-button'
//                   >
//                     {inactiveButtonName || 'Inactive'}
//                   </button>
//                 </div>
//               </>
//             ) : null}
//             {exportShow ? (
//               <div className='sub_button'>
//                 <button
//                   className='dt-btn dt-btn-outline-primary dt-btn-sm'
//                   onClick={handleExport}
//                   data-cy='export-button'
//                 >
//                   {exportButtonName || 'Export to CSV'}
//                 </button>
//               </div>
//             ) : null}
//             {importShow ? (
//               <div className='sub_button'>
//                 <form action='#'>
//                   <div className='input-file-container'>
//                     <input
//                       className='input-file'
//                       id='my-file'
//                       type='file'
//                       onChange={handleImport}
//                       data-cy='import-file-link'
//                     />
//                     <label
//                       className='dt-btn dt-btn-outline-primary dt-btn-sm input-file-trigger'
//                       htmlFor='my-file'
//                     >
//                       Import
//                     </label>
//                   </div>
//                 </form>
//               </div>
//             ) : null}

//             {importShow1 ? (
//               <button
//                 className='dt-btn dt-btn-outline-primary dt-btn-sm ms-2'
//                 onClick={handleClickImport}
//                 data-cy='import-show-button'
//               >
//                 Import
//               </button>
//             ) : null}

//             {sortShow ? (
//               <div
//                 className='sub_button'
//                 onClick={async () => {
//                   handleGetAllData && handleGetAllData()
//                   setOpenSortModal(true)
//                 }}
//                 data-cy='sort-show-button'
//               >
//                 <button className='dt-btn dt-btn-outline-primary dt-btn-sm' data-cy='sort-button'>
//                   {sortButtonName || 'Sort'}
//                 </button>
//               </div>
//             ) : null}
//           </div>
//         </div>
//       </div>

//       <SortModal
//         isOpen={openSortModal}
//         handleClose={handleCloseOpenSortModal}
//         data={sortData}
//         setSortData={setSortData}
//         sortButtonName={sortButtonName}
//         handleSubmitSort={handleSubmitSort}
//         loading={loading}
//         setSortInnerData={setSortInnerData}
//         setSortInnerMostData={setSortInnerMostData}
//         setSortInnerMostChildData={setSortInnerMostChildData}
//       />
//     </>
//   )
// }

// export default DesignComponent
